module.exports = __webpack_public_path__ + "img/jyzt-icon3.a20adc96.png";